import { NativeBaseProvider, Text, Slide, CloseIcon, IconButton, Collapse, Alert, useToast, Box, Center, Heading, VStack, FormControl, Input, Link, Button, HStack, } from "native-base";
import { TouchableOpacity } from "react-native";
import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import AsyncStorage from '@react-native-async-storage/async-storage';

export default function Login({ navigation }) {
    const [formData, setData] = React.useState({});
    const [DataUser, setDataUser] = React.useState({});
    const [errors, setErrors] = React.useState("");
    const [show, setShow] = React.useState(false);





    function login() {
        axios
            .get("https://birdra1n.x10.bz/AuthMail/singIN/", {
                params: {
                    username: formData.username,
                    password: formData.password
                },
            })
            .then(function (response) {
                var req = response.data;

                if (req.error == undefined) {
                    const jsonValue = JSON.stringify(req)
                    AsyncStorage.setItem('@data_user', jsonValue)
                    navigation.navigate('Dashboard');
                } else {
                    setErrors(req.error);
                    setShow(true)
                    setTimeout(() => {
                        setShow(false);
                    }, 1000);

                }
            });

    }

    /*const SlideTOP = () => {
        return(
            <Center>
                <Collapse isOpen={show} bottom={0.5}>
                <Alert  w="100%" variant={'left-accent'} colorScheme="red" status="success">
                <VStack space={2} flexShrink={1} w="100%">
                  <HStack flexShrink={1} space={2} alignItems="center" justifyContent="space-between">
                    <HStack space={2} flexShrink={1} alignItems="center">
                      <Alert.Icon />
                      <Text>
                        Selection successfully moved!
                      </Text>
                    </HStack>
                  </HStack>
                </VStack>
              </Alert>
                </Collapse>
            </Center>
        )
    };*/

    return (
        <NativeBaseProvider>
            <Slide in={show} placement="top">
                <Alert justifyContent="center" status="error">
                    <Alert.Icon />
                    <Text color="error.600" fontWeight="medium">
                        {errors}
                    </Text>
                </Alert>
            </Slide>
            <Box safeArea w={'100%'} h={'100%'} bg={'white'}>


                <Center top={-32}>
                    <Box safeArea p="2" py="8" w="90%" maxW="290">
                        <Heading size="lg" fontWeight="600" color="coolGray.800" _dark={{
                            color: "warmGray.50"
                        }}>
                            AuthEmailPHP
                        </Heading>
                        <Heading mt="1" _dark={{
                            color: "warmGray.200"
                        }} color="coolGray.600" fontWeight="medium" size="xs">
                            Sign in to continue!
                        </Heading>

                        <VStack space={3} mt="5">
                            <FormControl >
                                <FormControl.Label>Username</FormControl.Label>
                                <FormControl.ErrorMessage _text={{
                                    fontSize: 'xs'
                                }}>
                                    error
                                </FormControl.ErrorMessage>
                                <Input onChangeText={value => setData({
                                    ...formData,
                                    username: value
                                })} />
                            </FormControl>
                            <FormControl>
                                <FormControl.Label>Password</FormControl.Label>
                                <Input type="password" onChangeText={value => setData({
                                    ...formData,
                                    password: value
                                })} />
                                <Link _text={{
                                    fontSize: "xs",
                                    fontWeight: "500",
                                    color: "indigo.500"
                                }} alignSelf="flex-end" mt="1">
                                    Forget Password?
                                </Link>
                            </FormControl>
                            <Button mt="2" colorScheme="indigo" onPress={() => login()}>
                                Sign in
                            </Button>
                            <HStack mt="6" justifyContent="center">
                                <Text fontSize="sm" color="coolGray.600" _dark={{
                                    color: "warmGray.200"
                                }}>
                                    I'm a new user.{" "}
                                </Text>
                                <TouchableOpacity onPress={()=>navigation.navigate('register')}>
                                    <Box _text={{
                                        color: "indigo.500",
                                        fontWeight: "medium",
                                        fontSize: "sm"
                                    }} href="#">
                                        Sign Up
                                    </Box>
                                </TouchableOpacity>
                            </HStack>
                        </VStack>
                    </Box>

                </Center>
            </Box>
        </NativeBaseProvider>
    );
}